
import * as Yup from 'yup';

export const EMAIL_LIST_SEPARATOR = /[\n,;]+/;

export const parseEmailList = (value) => {
    if (!value) return [];

    return String(value)
        .split(EMAIL_LIST_SEPARATOR)
        .map(email => email.trim())
        .filter(email => email != '');
}

const isEmailList = (value) => {
    const emails = parseEmailList(value);

    if (!emails.length) return true;

    return emails.every(email => Yup.string().email().isValidSync(email));
}

export const InquiryCategorySchema = {
    label: Yup.string()
        .trim()
        .max(200, 'The label must be at most 200 characters.')
        .required('The label field is required.'),
    value: Yup.string()
        .trim()
        .max(200, 'The value must be at most 200 characters.')
        .required('The value field is required.'),
    recipient_emails: Yup.string()
        .trim()
        .required('The recipient emails field is required.')
        .test(
            'valid_recipient_emails',
            'Please enter valid email addresses, one per line.',
            isEmailList
        ),
    cc_emails: Yup.string()
        .trim()
        .nullable()
        .test(
            'valid_cc_emails',
            'Please enter valid email addresses, one per line.',
            isEmailList
        ),
    is_active: Yup.boolean(),
}

export const ClientInquiryCategorySchema = Yup.object({
    ...InquiryCategorySchema,
})

export const ServerInquiryCategorySchema = Yup.object({
    inquiry_category: Yup.object().shape({
        ...InquiryCategorySchema
    }),
})

export const InquiryCategoryDeleteSchema = Yup.object({
    id: Yup.number()
        .required('The inquiry category ID is required.'),
})
